import * as React from 'react'

import { Field } from 'embed/constants'
import { Fields } from 'embed/constants/fields'

import { StepTitle } from 'embed/components/Application/StepTitle'
import { ApplicationField } from 'embed/components/ApplicationField/container'
import { Product } from 'even-ts-static'
import Wrapper from '../Wrapper'

export interface Props {
  directReferral: boolean
  dispatchBackToStepOne: () => void
  handleChangeAndContinue: (field: Field, value) => void
  onBack: () => void
  onContinue: () => void
  stepByStepApplicationStepIsValid: boolean
  currentStep: number
  totalNumberOfSteps: number
}

const StepbystepApplicationStepSLRGraduateDegreeLevel: React.SFC<Props> = (props) => (
  <Wrapper {...props}>
    <StepTitle>Which doctorate degree do you have?</StepTitle>
    <ApplicationField product={Product.Loan} field={Fields.GraduateDegree} />
  </Wrapper>
)

export default StepbystepApplicationStepSLRGraduateDegreeLevel
